import { LogLevel } from '@core/logger';
import { EnvironmentBase } from '../environment.base';

export const environment: EnvironmentBase = {
  baseUrl: 'https://did-api-dev.powerspaces-uat.gsusrem.telekom-dienste.de',
  production: false,
  logLevel: LogLevel.All,
  hmr: false,
  AadAuthorityDomain: 'powerspacesnemodev.b2clogin.com',
  AadClientId: '30ed9708-4057-4c75-b326-612c1873d121',
  AadEditprofileUrl:
    'https://powerspacesnemodev.b2clogin.com/powerspacesnemodev.onmicrosoft.com/B2C_1_profileediting',
  AadScope: 'https://powerspacesnemodev.onmicrosoft.com/did-api-dev/Portal.SignIn',
  AadSignupSigninUrl:
    'https://powerspacesnemodev.b2clogin.com/powerspacesnemodev.onmicrosoft.com/B2C_1A_SOCIAL_SIGNIN_ONLY',
};
